<template>
  <div class="Login full-height">
    <ld-header
      @click-left="$router.push({ path: '/home' })"
      :z-index="99999"
      class="headerBack"
    />
    <ld-statusbar bg-white />
    <div class="title">
      <div class="logo">
        <img :src="loginConfig.logoUrl">
      </div>
    </div>

    <div class="welcome font20 font-lg">
      欢迎使用 {{ loginConfig.pageName }}
    </div>

    <div class="login-input">
      <van-field
        v-if="loginType === 1"
        v-model="telphone"
        size="large"
        placeholder="请输入登录账号"
      />
      <van-field
        v-else
        type="number"
        v-model="telphone"
        :placeholder="$t('G040','请输入手机号码')"
      />
    </div>

    <div class="login-input">
      <van-row type="flex">
        <van-col span="18">
          <van-field
            :type="(loginType === 1 && !passwordShow) ? 'password' : 'text'"
            v-model="password"
            class="text-space"
            :maxlength="loginType === 1 ? undefined : 6"
            :placeholder="loginType === 1 ? $t('G028','请输入密码') : $t('G235','请输入验证码')"
            @change="function(){}"
            @focus="function(){}"
            @blur="function(){}"
            autocomplete="off"
          />
        </van-col>
        <van-col span="6">
          <div
            v-if="loginType === 1"
            class="text-right"
          >
            <ld-icon
              v-if="passwordShow"
              @click="passwordShow = false"
              class="gray valid-password van-hairline--right"
              type="iconxianshi"
            />
            <ld-icon
              v-else
              @click="passwordShow = true"
              class="gray valid-password van-hairline--right"
              type="iconyincangmima"
            />
            <router-link
              class="main-color font12"
              to="/resetPassword"
            >
              忘记密码
            </router-link>
          </div>
          <a
            @click="getSmsValidCode()"
            v-if="loginType === 2"
            class="font12 text-right main-color"
          >{{ smsCodeTips }}</a>
        </van-col>
      </van-row>
    </div>

    <van-row
      type="flex"
      align="center"
      class="login-input"
      v-if="loginType === 1 && failCount >= failCountThreshold"
    >
      <van-col span="18">
        <van-field
          class="font18"
          type="text"
          v-model="validCode"
          maxlength="6"
          placeholder="请输入校验码"
          autocomplete="off"
          @input="changeValidCode"
        />
      </van-col>
      <van-col span="6">
        <img
          :src="validCodeImgSrc"
          @click="getImgValidCode()"
          class="valid-img"
        >
      </van-col>
    </van-row>

    <div class="login-prompt">温馨提示：本商旅平台仅供签约企业使用，如无法登录请联系贵司差旅负责人</div>
    <div class="license">
      <van-checkbox
        v-model="checkedLicense"
      >
        阅读并同意我们的<span
          class="main-color"
          @click.stop="showLicense=true"
        >《服务协议》
        </span>和<span
          class="main-color"
          @click.stop="showLicense2=true"
        >《隐私条款》
        </span>
      </van-checkbox>
    </div>

    <ld-button
      @click.native="getCorp"
      class="login_btn"
      main2
      :disabled="(telphone&&password)==false"
      size="lg"
    >
      登录
    </ld-button>

    <van-row class="forget">
      <van-col span="12">
        <a
          v-if="loginType === 2"
          class="fl main-color"
          @click="changeLoginType(1)"
        >
          密码登录
        </a>
        <a
          v-if="loginType === 1"
          class="fl main-color"
          @click="changeLoginType(2)"
        >
          短信验证码登录
        </a>
      </van-col>
      <!-- 宇哥需求隐藏注册 -->
      <van-col
        span="12"
        class="text-right"
        v-if="false"
      >
        <router-link
          class="main-color"
          to="/register"
        >
          注册
        </router-link>
      </van-col>
    </van-row>


    <van-popup
      v-model="showLicense"
      position="right"
      :close-on-popstate="true"
      class="full-height full-width"
    >
      <ld-header @click-left="showLicense = false">
        《{{ loginConfig.pageName }}服务协议》
      </ld-header>
      <div class="font14 showLicense">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <div v-if="loginConfig.by5">
            <pre
              v-html="loginConfig.by5"
              class="pad8 pre-wrap"
            />
          </div>
        </mescroll-vue>
      </div>
    </van-popup>

    <van-popup
      v-model="showLicense2"
      position="right"
      :close-on-popstate="true"
      class="full-height full-width"
    >
      <ld-header @click-left="showLicense2 = false">
        《{{ loginConfig.pageName }}隐私条款》
      </ld-header>
      <div class="font14 showLicense2">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <div v-if="loginConfig.by2">
            <pre
              v-html="loginConfig.by2"
              class="pad8 pre-wrap"
            />
          </div>
        </mescroll-vue>
      </div>
    </van-popup>

    <van-dialog
      v-model="showXy"
      title="请阅读《服务协议》和《隐私条款》"
      show-cancel-button
      cancel-button-text="不同意"
      confirm-button-text="同意"
      @confirm="agree"
    >
      <div class="font14 gray box">
        <div class="indent">
          依据最新法律要求，我们更新了
          <span
            class="main-color"
            @click.stop="showLicense=true"
          >《服务协议》</span>和
          <span
            class="main-color"
            @click.stop="showLicense2=true"
          >《隐私条款》</span>，请您务必审慎阅读、充分理解相关条款内容，并确定了解我们对您个人信息的处理规则。
        </div>
        <div class="indent">
          点击同意即代表您已阅读并理解以上政策，您可立即开始使用我们的产品和服务；如果您点击不同意，将无法使用我们提供的服务。
        </div>
        <div class="indent">
          我们将尽全力保护您的个人信息和合法权益，再次感谢您对本产品的信任！
          （点击<span
            class="main-color"
            @click.stop="showLicense=true"
          >《服务协议》</span>和
          <span
            class="main-color"
            @click.stop="showLicense2=true"
          >《隐私条款》</span>，打开服务协议和隐私条款内容页面）
        </div>
      </div>
    </van-dialog>

    <!--   -->
    <choose-corp
      ref="corp"
      :btn-text="(loginType==1||(loginType==2&&hasCompId==false))?'登录':'获取验证码'"
      :comp-list="compList"
      @selected="corpChecked"
    />
  </div>
</template>

<script>
import { Field, Popup, Checkbox ,Dialog,RadioGroup, Radio,CellGroup,Cell} from 'vant'

import { API_DEFAULT_CONFIG } from 'Config'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import { validators } from 'Utils/valid'
// import { update } from 'CommonUtils/updateApp.js'
import { isH5,getDeviceInfo } from 'CommonUtils/plus.js'
import {localget, localremove, localset} from 'Utils/storage.js'
import chooseCorp from 'Views/User/Login/chooseCorp/index.vue'

import { standardSSO } from 'Utils/ssoLogin'
import { parseQueryString } from 'Utils/string'
import ldStatusbar from 'Common/ldStatusbar'
import CryptoJS from 'crypto-js'


export default {
  components: {
    ldButton,
    [Field.name]:Field,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
    [Checkbox.name]:Checkbox,
    [Popup.name]:Popup,
    [Dialog.name]:Dialog,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    chooseCorp,
    ldStatusbar
  },
  data () {
    return {
      telphone: '',
      showLicense:false,
      showLicense2:false,
      passwordShow: false,
      password: '',
      corpList: [], // 企业列表
      compList:[],
      loginType: 1, // 1工号/手机号登录；2手机+验证码登录
      failCount: 0, // 登录失败次数
      failCountThreshold: 3, // 登录失败次数阈值
      validCode: '',
      validateCodeId: '', // 获取校验码的时间戳
      validCodeImgSrc: '',
      smsCodeTips: '获取验证码',
      checkedLicense: false,
      showXy:false,//是否显示隐私协议
      corpId:'',
      remember:false,//记住登录状态
      hasCompId:true//区分验证码登录时  总公司ID存在状态 默认存在
    }
  },
  created () {
    var params=parseQueryString()
    if(params&&params.loginType){
      standardSSO(params).then(res=>{
        this.$store.commit('SET_USERINFO', res.data)
      })
    }
  },

  mounted () {
    // update()//app 更新检查
    /**判断是否第一次启动
         * launchFlag 存在说明不是第一次启动
         * launchFlag 不存在 说明第一次启动
        */
    let launchFlag=localget('launchFlag')||''
    if(launchFlag){
      // 获取上一次登录的账号密码
      const AutoLogin_Params = localget('AutoLogin') || {}
      this.telphone = AutoLogin_Params.loginName
      if(!AutoLogin_Params.loginOut){
        this.password = AutoLogin_Params.password
        this.getImgValidCode()
      }
    }else if(isH5()){
      //如果是h5 显示隐私协议
      this.showXy=true
    }

    setTimeout(() => {
      if (this.canSubmit) {
        this.checkedLicense = true
        this.getCorp()
      }
    }, 500)

    let lastRemember=localget('lastRemember')||{}
    if(lastRemember.corpId){
      this.loginConfig.compaySuper=lastRemember.compId
      this.corpId=lastRemember.corpId
      this.remember=true
    }
  },
  methods: {
    // 同意隐私协议
    agree(){
      this.showXy=false
      this.checkedLicense=true
      localset('launchFlag',new Date())
    },
    getCorpData() {
      this.clearCacheBeforeLogin()

      let finalPassword = '' + this.password
      if (this.loginType === 1){
        const key = CryptoJS.enc.Latin1.parse(this.telphone.padEnd(16, '\0').slice(0, 16));
        let srcPassword = CryptoJS.enc.Utf8.parse(this.password)
        let encrypted = CryptoJS.AES.encrypt(srcPassword, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        finalPassword = encrypted.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase()
      }

      let params = {
        'compId': this.loginConfig.compaySuper,
        'loginType': this.loginType,
        'loginName': this.telphone,
        'password': finalPassword,
        'validateCode': this.validCode,
        'validateCodeId': this.validateCodeId,
      }
      var self=this
      this.$store.dispatch('getCorpList', params).then(({item,msg}) => {
        if(Array.isArray(item)){
          if(item.length==0){
            self.$toast(msg)
            return
          }else if(item.length==1){
            var comp=item[0]
            if(comp.vipCorpList.length==1){
              self.corpChecked(comp.companyId,comp.vipCorpList[0].corpId,false)
            }else{
              self.compList=item
              self.$refs.corp.toggle()
            }
          }else{
            self.compList=item
            self.$refs.corp.toggle()
          }
        }else{
          self.$toast(msg)
        }
      })
    },
    // 选中企业
    corpChecked(compId,corpId,remember){
      if(compId){
        this.loginConfig.compaySuper=compId
      }
      this.corpId=corpId
      this.remember=remember
      if(this.remember){
        localset('lastRemember',{corpId:corpId,compId:this.loginConfig.compaySuper})
      }
      //关闭企业选择框
      if(this.loginType==1){
        this.login(this.corpId)
      }else if(this.loginType==2){
        if(this.hasCompId==false){
          this.getSmsValidCode()
        }else{
          this.login(this.corpId)
        }
      }
    },

    // 获取企业列表
    async getCorp() {
      if (this.checkedLicense == false) {
        this.$toast('请先阅读《隐私政策和服务协议》并选择同意')
        return
      }
      let valider = validators['is-string'](this.validCode, '校验码')
      if (this.loginType === 1 && this.failCount > this.failCountThreshold && !valider.valid) {
        this.$validErrorTips(valider.msg)
        return
      }
      if (!this.telphone || !this.password) return
      try {
        if (this.corpId && this.loginConfig.compaySuper) {
          this.login(this.corpId)
        } else {
          this.getCorpData()
        }
      } catch (err) {
        console.log(err)
        this.$responeFailTips(err.msg)
        /**
         * 用户名 密码登录情况下
         * 失败超过失败次数阈值 输入验证码
         */
        if (this.loginType === 1) {
          this.failCount = err.failCount || this.failCount
          if (this.failCount >= this.failCountThreshold) {
            this.getImgValidCode()
          }
        }
      }
    },
    clearCacheBeforeLogin(){
      console.log("clearCacheBeforeLogin 登录前清除缓存信息")
      localremove('VUEX_STATE')
      //火车票12306相关缓存start
      this.$store.dispatch('invoice/clearInvoiceState'); // 清除火车票发票相关缓存信息
      this.$store.commit('tr/update12306Info', {
        trainAccount: '',
        password: '',
        isLoginSucccess: false,
      });
      //火车票12306相关缓存end

    },
    // 登录
    async login (corpId) {
      if(this.remember){
        localset('lastRemember',{corpId:corpId,compId:this.loginConfig.compaySuper})
      }

      let finalPassword = '' + this.password
      if (this.loginType === 1){
        const key = CryptoJS.enc.Latin1.parse(this.telphone.padEnd(16, '\0').slice(0, 16));
        let srcPassword = CryptoJS.enc.Utf8.parse(this.password)
        let encrypted = CryptoJS.AES.encrypt(srcPassword, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        finalPassword = encrypted.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase()
      }

      let deviceInfo=getDeviceInfo()
      let params = {
        loginType: this.loginType,
        loginName: this.telphone,
        password: finalPassword,
        compId: this.loginConfig.compaySuper,
        corpId,
        deviceId :deviceInfo.uuid||'',//(string, optional): 设备标识 ,
        deviceShortname :deviceInfo.companyVendor?(deviceInfo.companyVendor+'-'+deviceInfo.phoneModel):'',//(string, optional): 设备型号 ,
        autologinType :2,//(integer, optional): 登陆方式,1-自动登录2-手动登录
      }
      // alert('login页面 登录入参'+JSON.stringify(params))
      this.$store.dispatch('login', params)
    },
    // 获取短信验证码
    async getSmsValidCode () {
      if(this.smsCodeTips !== '获取验证码' && this.smsCodeTips !== '重新发送') return false

      let valider = validators['is-string'](this.telphone, '手机号码')
      if (!valider.valid) {
        this.$validErrorTips(valider.msg)
        return
      }
      if(this.loginConfig.compaySuper){
        this.getCode()
      }else{
        this.hasCompId=false
        this.getCorpData()
      }
    },
    //获取短信验证码
    getCode(){
      this.$api['user/smsCodeGet']({
        compId: this.loginConfig.compaySuper,
        phoneNumber: this.telphone,
        type: '登录'
      }).then(() => {
        // 倒计时 60s
        let threshold = 60,
          count = 0
        let time = setInterval(() => {
          let diff = threshold - count
          count ++
          this.smsCodeTips = `${diff} S`
          if(diff === 0) {
            clearInterval(time)
            this.smsCodeTips = '重新发送'
          }
        }, 1000)
      })
    },
    // 获取图片验证码
    async getImgValidCode () {
      this.validateCodeId = new Date().getTime()
      this.validCodeImgSrc = `${API_DEFAULT_CONFIG.URL.api}/obt/getValidateCode?validateCodeId=${this.validateCodeId}`
    },
    // 改变登录方式
    changeLoginType (type) {
      this.loginType = type
      this.password = ''
    },
    changeValidCode() {
      if (this.validCode.length > 6) {
        this.validCode = this.validCode.slice(0, 6)
      }else {
        this.validCode = this.validCode
      }
    }
  },
  computed: {
    canSubmit: vm => !!(vm.telphone && vm.password),
    ...mapGetters(['loginConfig'])
  }
}
</script>

<style lang="less" scoped>
.Login {
  color: @color-text-black;
  background-color: @color-text-white;
  padding: 0 30px;

  .login-input {
    border-bottom: 1px solid @color-background-lightGray;

    .van-row--flex {
      align-items: baseline;
    }

    .van-field {
      padding: 48px 0 12px;

      .van-field__control {
        font-size: 16px;
      }
    }
  }

  .login-prompt {
    color: red;
    margin-top: 16px;
  }

  .title {
    padding-top: 50px;
  }

  .logo img {
    width: 50px;
    border-radius: 50%;
  }

  .welcome {
    padding: 0 0 44px;
  }

  .login_btn {
    margin-top: 24px;
  }

  .valid-img {
    .valid-password {
      padding-right: 10px;
    }
  }

  .forget {
    margin-top: 40px;
  }

  .license {
    margin-top: 16px;
    font-size: 13.5px;
  }

  .showLicense {
    height: calc(100vh - 50px);
    padding: 10px;
    text-indent: 20px;
  }

  .box {
    padding: 20px;
  }

  .indent {
    text-indent: 20px;
  }
}

.showLicense2 {
  height: calc(100vh - 50px);
  padding: 10px;
  text-indent: 20px;
}

.headerBack {
  position: absolute;
  left: -10px;
}
</style>
